module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptust326-1200x2490.66bbdef6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptust326-1200x2490.jpg
// module id = 1008
// module chunks = 37